/* Policy page — reading-progress bar, sticky scroll-spy TOC, smooth jumps, print.
   Two modes:
     • Content mode  — body from the Page → Content field; the TOC is built from the <h2>s here.
     • Legacy mode   — body from editor blocks; the TOC is pre-rendered by Liquid.
   Guarded so it binds once even if the section reloads in the theme editor. */
(function () {
  if (window.__tytPolicyInit) return;
  window.__tytPolicyInit = true;

  var reduceMotion = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function slugify(text, used) {
    var base = (text || '').toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '') || 'section';
    var id = base, i = 2;
    while (used[id]) { id = base + '-' + i; i++; }
    used[id] = true;
    return id;
  }

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  /* In content mode, build the TOC rows from the <h2> headings and return the
     [section elements, toc links] the scroll-spy will use. */
  function buildAutoToc(root) {
    var content = root.querySelector('[data-tyt-policy-content]');
    var list = root.querySelector('[data-tyt-toc-list]');
    if (!content || !list) return null;

    var heads = Array.prototype.slice.call(content.querySelectorAll('h2'));
    if (!heads.length) return null;

    list.innerHTML = '';  // clear any server-rendered rows before building from headings

    var used = {};
    var links = [];
    heads.forEach(function (h, idx) {
      if (!h.id) h.id = slugify(h.textContent, used);
      else used[h.id] = true;

      var a = document.createElement('a');
      a.className = 'tyt-policy-toc__row';
      a.href = '#' + h.id;
      a.setAttribute('data-tyt-toc-link', h.id);

      var no = document.createElement('span');
      no.className = 'tyt-policy-toc__no';
      no.textContent = pad(idx + 1);

      var title = document.createElement('span');
      title.className = 'tyt-policy-toc__title';
      title.textContent = h.textContent;

      a.appendChild(no);
      a.appendChild(title);
      list.appendChild(a);
      links.push(a);
    });

    return { sections: heads, links: links };
  }

  function init() {
    var root = document.querySelector('[data-tyt-policy]');
    if (!root) return;

    /* ── reading-progress bar ── */
    var fill = document.querySelector('[data-tyt-policy-progress] .tyt-policy-progress__fill');
    if (fill) {
      var tick = function () {
        var h = document.documentElement;
        var max = (h.scrollHeight - h.clientHeight) || 1;
        var pct = Math.min(1, Math.max(0, (h.scrollTop || window.pageYOffset) / max));
        fill.style.width = (pct * 100) + '%';
      };
      window.addEventListener('scroll', tick, { passive: true });
      window.addEventListener('resize', tick, { passive: true });
      tick();
    }

    /* ── resolve TOC sections + links (content mode builds them; legacy reads them) ── */
    var built = buildAutoToc(root);
    var sections, links;
    if (built) {
      sections = built.sections;
      links = built.links;
    } else {
      sections = Array.prototype.slice.call(root.querySelectorAll('[data-tyt-policy-sec]'));
      links = Array.prototype.slice.call(root.querySelectorAll('[data-tyt-toc-link]'));
    }

    function setActive(id) {
      links.forEach(function (a) {
        var on = a.getAttribute('data-tyt-toc-link') === id;
        a.classList.toggle('is-active', on);
        if (on) { a.setAttribute('aria-current', 'true'); }
        else { a.removeAttribute('aria-current'); }
      });
    }

    /* ── scroll-spy ── */
    if (sections.length && 'IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entries) {
        var visible = entries.filter(function (e) { return e.isIntersecting; })
          .sort(function (a, b) { return a.boundingClientRect.top - b.boundingClientRect.top; });
        if (visible[0]) setActive(visible[0].target.id);
      }, { rootMargin: '-120px 0px -65% 0px', threshold: 0 });
      sections.forEach(function (el) { obs.observe(el); });
      setActive(sections[0].id);
    }

    /* ── smooth jump links (gated on reduced-motion) ── */
    function scrollToEl(el) {
      var top = el.getBoundingClientRect().top + window.pageYOffset - 96;
      window.scrollTo({ top: top, behavior: reduceMotion ? 'auto' : 'smooth' });
    }
    links.forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('data-tyt-toc-link');
        var el = document.getElementById(id);
        if (el) { e.preventDefault(); scrollToEl(el); }
      });
    });

    var topLink = root.querySelector('[data-tyt-policy-top]');
    if (topLink) {
      topLink.addEventListener('click', function (e) {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
      });
    }

    /* ── print ── */
    var printBtn = root.querySelector('[data-tyt-policy-print]');
    if (printBtn) {
      printBtn.addEventListener('click', function () { window.print(); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
